/**
 * 平台: 支付宝webview
 * 通用能力:
 * 1.bridge：alipayReady (window.AlipayJSBridge)
 * 2.登录: None
 * 3.定位: alipayLocate
 * 4.订阅: None
 * 5.分享: None
 */
import { utils } from '@didi/webx-js-core';
import { AlipayJump } from './goTo';
import { storage } from '../../../storage';
function commonJump(loadParams, xenv, commonParams = {}) {
    new AlipayJump(loadParams, xenv, commonParams).doJump();
}
/**
 * 支付宝webview bridgeReady
 * @param callback
 */
const alipayReady = (callback) => {
    let bridge = window.AlipayJSBridge;
    if (typeof bridge !== 'undefined') {
        callback(bridge);
    }
    else {
        document.addEventListener('AlipayJSBridgeReady', (bridge) => {
            callback(bridge);
        });
    }
};
const alipayLocate = () => {
    return new Promise((resolve, reject) => {
        alipayReady(sdk => {
            sdk.call('getLocation', ret => {
                if (ret.error) {
                    /* 获取定位信息失败 存入缓存 */
                    storage.locationInfo = {};
                    let newRiskParams = Object.assign({}, storage.riskParams, { latitude: undefined, longitude: undefined });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    reject(ret.errorMessage);
                }
                else {
                    /* 获取定位信息成功 存入缓存 */
                    storage.locationInfo = {
                        lat: ret.latitude,
                        lng: ret.longitude
                    };
                    let newRiskParams = Object.assign({}, storage.riskParams, { latitude: ret.latitude, longitude: ret.longitude });
                    utils.cleanEmptyKey(newRiskParams);
                    storage.riskParams = newRiskParams;
                    resolve({
                        lat: ret.latitude,
                        lng: ret.longitude
                    });
                }
            });
        });
    });
};
const getPx = (num) => {
    let radio = document.documentElement.clientWidth / 750;
    return `${num * radio}px`;
};
/**
 * weixinInvokeShareMask
 * @description webview环境下 无主动分享机制时 蒙层兜底
 *   兼容微信
 */
const alipayInvokeShare = () => {
    const shadowImg = '//dpubstatic.udache.com/static/dpubimg/0e3e87f7-215c-48c2-9320-26577ad72bd2.png';
    const $dom = document.createElement('div');
    $dom.style.position = 'fixed';
    $dom.style.width = '100%';
    $dom.style.height = '100%';
    $dom.style.left = '0';
    $dom.style.top = '0';
    $dom.style.backgroundColor = 'rgba(0,0,0,.6)';
    $dom.style.zIndex = '10000';
    $dom.style.backgroundImage = `url(${shadowImg})`;
    $dom.style.backgroundRepeat = 'no-repeat';
    $dom.style.backgroundSize = `${getPx(270)} auto`;
    $dom.style.backgroundPositionY = '0';
    $dom.style.backgroundPositionX = getPx(750 - 270);
    setTimeout(() => {
        // 延时300ms后设置onclick方法，避免移动端点击穿透
        $dom.onclick = () => {
            document.body.removeChild($dom);
        };
    }, 300);
    document.body.appendChild($dom);
};
export { alipayReady, alipayLocate, commonJump as alipayCommonJump, alipayInvokeShare };
